export default __webpack_public_path__ + "static/media/english-to-tagalog-logo.9e863f6e.png";